module.exports = __webpack_public_path__ + "assets/img/26_875.fd165a15.jpg";